/**
 * Which renderer a presentation entered now uses: the overlay above the wall,
 * or the canvas when this device chose the old canvas (Part 06 decision 9).
 */
import type {
  FocusRendererKind,
  PresentationState,
} from "@/lib/focus/focus-types";
import { isWallActive } from "@/stores/workspace-view-store";

export function focusRendererKind(): FocusRendererKind {
  return isWallActive() ? "overlay" : "canvas";
}

/**
 * The focus presentation that hides every other frame through the canvas
 * store's `focusHiddenFrameIds`: only the canvas renderer hides frames. The
 * overlay draws above the wall, so the set stays empty there.
 */
export function canvasFocusPresentation(
  presentation: PresentationState | null,
): PresentationState | null {
  return presentation?.variant === "focus" && presentation.renderer === "canvas"
    ? presentation
    : null;
}
